import { HeadersEnum } from 'src/app/@Common/enum/headers.enum';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class UsuarioInterceptor implements HttpInterceptor {

  private getAccessToken(): string | null {
    if (typeof localStorage === 'undefined') {
      return null;
    }
    const sysId = environment.systemId || 1;
    const envName = (environment.environment || 'Desarrollo').trim().toLowerCase();
    return (
      localStorage.getItem(`accessToken_${sysId}_${envName}`) ||
      localStorage.getItem('accessToken') ||
      null
    );
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // No sobreescribir las llamadas directas de autenticación a Bóveda (/api/Login)
    if (req.url.includes('/api/Login')) {
      return next.handle(req);
    }

    const usuario = localStorage.getItem(HeadersEnum.USUARIO);
    const accion = localStorage.getItem(HeadersEnum.ACCION);
    const token = this.getAccessToken();

    if (!usuario && !token) {
      return next.handle(req);
    }

    const setHeaders: { [name: string]: string } = {};

    if (usuario !== null && !req.headers.has('user')) {
      setHeaders['user'] = usuario;
    }
    if (usuario !== null && !req.headers.has('accion')) {
      setHeaders['accion'] = accion === null ? '' : accion;
    }
    if (token && !req.headers.has('Authorization')) {
      setHeaders['Authorization'] = `Bearer ${token}`;
    }

    const cloneRequest = req.clone({ setHeaders });
    return next.handle(cloneRequest);
  }
}
